const setHeader = HEADER => ({ HEADER });
const setFooter = FOOTER => ({ FOOTER });


module.exports = ({
  FRAGMENT_HEADER,
  FRAGMENT_FOOTER,
}) => ({
  ...setHeader(FRAGMENT_HEADER),
  ...setFooter(FRAGMENT_FOOTER),
});
